var map = {
	"./Detetive_Nini": 176,
	"./Detetive_Nini.png": 176,
	"./Gatilho-botao": 177,
	"./Gatilho-botao.svg": 177,
	"./about": 178,
	"./about.png": 178,
	"./abranda": 179,
	"./abranda.png": 179,
	"./age": 180,
	"./age.png": 180,
	"./ana_nervosa": 181,
	"./ana_nervosa.png": 181,
	"./ana_sobre": 182,
	"./ana_sobre.png": 182,
	"./ana_triste": 183,
	"./ana_triste.png": 183,
	"./aranha": 184,
	"./aranha.png": 184,
	"./audio": 185,
	"./audio.svg": 185,
	"./avatar": 186,
	"./avatar.png": 186,
	"./barco": 187,
	"./barco.png": 187,
	"./blobs/blob-brown": 188,
	"./blobs/blob-brown.svg": 188,
	"./blobs/blob-green-light": 189,
	"./blobs/blob-green-light.svg": 189,
	"./blobs/blob-orange": 190,
	"./blobs/blob-orange.svg": 190,
	"./blobs/blob-pink": 191,
	"./blobs/blob-pink.svg": 191,
	"./blobs/blob-purple": 192,
	"./blobs/blob-purple.svg": 192,
	"./blobs/blob-red": 193,
	"./blobs/blob-red.svg": 193,
	"./boca": 194,
	"./boca.png": 194,
	"./caixa": 195,
	"./caixa.svg": 195,
	"./carro": 196,
	"./carro.png": 196,
	"./certo": 197,
	"./certo.svg": 197,
	"./cesta": 198,
	"./cesta.png": 198,
	"./cesta2": 199,
	"./cesta2.png": 199,
	"./comportamento": 200,
	"./comportamento.svg": 200,
	"./contar1": 201,
	"./contar1.png": 201,
	"./contar2": 202,
	"./contar2.png": 202,
	"./contar3": 203,
	"./contar3.png": 203,
	"./contar4": 204,
	"./contar4.png": 204,
	"./desvantagens": 205,
	"./desvantagens.svg": 205,
	"./diploma": 206,
	"./diploma.png": 206,
	"./edgar_sobre": 207,
	"./edgar_sobre.png": 207,
	"./edgar_zangado": 208,
	"./edgar_zangado.png": 208,
	"./emotions/sebastiao-anger": 209,
	"./emotions/sebastiao-anger.svg": 209,
	"./emotions/sebastiao-fear": 210,
	"./emotions/sebastiao-fear.svg": 210,
	"./emotions/sebastiao-joy": 211,
	"./emotions/sebastiao-joy.svg": 211,
	"./emotions/sebastiao-sadness": 212,
	"./emotions/sebastiao-sadness.svg": 212,
	"./emotions/sebastiao-shame": 213,
	"./emotions/sebastiao-shame.svg": 213,
	"./entidades_organizadoras/cineicc": 214,
	"./entidades_organizadoras/cineicc.svg": 214,
	"./entidades_organizadoras/fct": 215,
	"./entidades_organizadoras/fct.svg": 215,
	"./entidades_organizadoras/fpceuc": 216,
	"./entidades_organizadoras/fpceuc.svg": 216,
	"./entidades_organizadoras/fpul": 217,
	"./entidades_organizadoras/fpul.svg": 217,
	"./entidades_organizadoras/uniao_europeia": 218,
	"./entidades_organizadoras/uniao_europeia.svg": 218,
	"./escadotes/escadote_10": 219,
	"./escadotes/escadote_10.png": 219,
	"./escadotes/escadote_3": 220,
	"./escadotes/escadote_3.png": 220,
	"./escadotes/escadote_4": 221,
	"./escadotes/escadote_4.png": 221,
	"./escadotes/escadote_5": 222,
	"./escadotes/escadote_5.png": 222,
	"./escadotes/escadote_6": 223,
	"./escadotes/escadote_6.png": 223,
	"./escadotes/escadote_7": 224,
	"./escadotes/escadote_7.png": 224,
	"./escadotes/escadote_8": 225,
	"./escadotes/escadote_8.png": 225,
	"./escadotes/escadote_9": 226,
	"./escadotes/escadote_9.png": 226,
	"./group": 227,
	"./group.svg": 227,
	"./lesson_5/ana_adivinhadora": 228,
	"./lesson_5/ana_adivinhadora.png": 228,
	"./lesson_5/animais": 229,
	"./lesson_5/animais.jpg": 229,
	"./lesson_5/caras": 230,
	"./lesson_5/caras.jpg": 230,
	"./lesson_5/edgar_exagerado": 231,
	"./lesson_5/edgar_exagerado.png": 231,
	"./lesson_5/nini_negativa": 232,
	"./lesson_5/nini_negativa.png": 232,
	"./lesson_5/sebastiao_pensamento": 233,
	"./lesson_5/sebastiao_pensamento.png": 233,
	"./lesson_5/sebastiao_saltitao": 163,
	"./lesson_5/sebastiao_saltitao.png": 163,
	"./lesson_5/sebastiao_saltitao.svg": 523,
	"./lesson_5/sebastiao_saltitao_large": 234,
	"./lesson_5/sebastiao_saltitao_large.png": 234,
	"./lesson_5/sebastiao_triste": 235,
	"./lesson_5/sebastiao_triste.png": 235,
	"./lesson_5/sebastiao_varios_pensamentos": 164,
	"./lesson_5/sebastiao_varios_pensamentos.png": 164,
	"./lesson_5/sebastiao_varios_pensamentos.svg": 524,
	"./lesson_7/nini_com_sucesso": 236,
	"./lesson_7/nini_com_sucesso.png": 236,
	"./lesson_7/nini_sem_sucesso": 237,
	"./lesson_7/nini_sem_sucesso.png": 237,
	"./lesson_7/sebastiao_barco": 238,
	"./lesson_7/sebastiao_barco.png": 238,
	"./lesson_7/sebastiao_carro": 239,
	"./lesson_7/sebastiao_carro.png": 239,
	"./lesson_7/sebastiao_cesta": 240,
	"./lesson_7/sebastiao_cesta.png": 240,
	"./lesson_7/sebastiao_com_sucesso": 241,
	"./lesson_7/sebastiao_com_sucesso.png": 241,
	"./lesson_7/sebastiao_oculos_mergulho": 242,
	"./lesson_7/sebastiao_oculos_mergulho.png": 242,
	"./lesson_7/sebastiao_patins": 243,
	"./lesson_7/sebastiao_patins.png": 243,
	"./lesson_7/sebastiao_ponte": 244,
	"./lesson_7/sebastiao_ponte.png": 244,
	"./lesson_7/sebastiao_sem_sucesso": 245,
	"./lesson_7/sebastiao_sem_sucesso.png": 245,
	"./lesson_9/grupo": 246,
	"./lesson_9/grupo.png": 246,
	"./lesson_9/nini_caderno": 247,
	"./lesson_9/nini_caderno.png": 247,
	"./lesson_9/pais": 248,
	"./lesson_9/pais.png": 248,
	"./lesson_9/sebastiao_urso": 249,
	"./lesson_9/sebastiao_urso.png": 249,
	"./logo": 250,
	"./logo.png": 250,
	"./mao": 251,
	"./mao.png": 251,
	"./nariz": 252,
	"./nariz.png": 252,
	"./nini_criancas": 253,
	"./nini_criancas.png": 253,
	"./nini_escada": 254,
	"./nini_escada.png": 254,
	"./nini_landing": 255,
	"./nini_landing.png": 255,
	"./nini_sobre": 256,
	"./nini_sobre.png": 256,
	"./nuvem": 257,
	"./nuvem.svg": 257,
	"./oculos_mergulho": 258,
	"./oculos_mergulho.png": 258,
	"./olho": 259,
	"./olho.png": 259,
	"./online": 260,
	"./online.svg": 260,
	"./online_zoom": 261,
	"./online_zoom.svg": 261,
	"./orelha": 262,
	"./orelha.png": 262,
	"./pais": 263,
	"./pais.png": 263,
	"./para": 264,
	"./para.png": 264,
	"./patins": 265,
	"./patins.png": 265,
	"./pause": 266,
	"./pause.png": 266,
	"./pensamentos": 267,
	"./pensamentos.svg": 267,
	"./play": 268,
	"./play.svg": 268,
	"./ponte": 269,
	"./ponte.png": 269,
	"./ponto_de_interrogacao": 270,
	"./ponto_de_interrogacao.svg": 270,
	"./presential": 271,
	"./presential.svg": 271,
	"./puzzle/puzzle_1": 272,
	"./puzzle/puzzle_1.png": 272,
	"./puzzle/puzzle_10": 273,
	"./puzzle/puzzle_10.png": 273,
	"./puzzle/puzzle_100": 274,
	"./puzzle/puzzle_100.png": 274,
	"./puzzle/puzzle_101": 275,
	"./puzzle/puzzle_101.png": 275,
	"./puzzle/puzzle_102": 276,
	"./puzzle/puzzle_102.png": 276,
	"./puzzle/puzzle_103": 277,
	"./puzzle/puzzle_103.png": 277,
	"./puzzle/puzzle_104": 278,
	"./puzzle/puzzle_104.png": 278,
	"./puzzle/puzzle_105": 279,
	"./puzzle/puzzle_105.png": 279,
	"./puzzle/puzzle_106": 280,
	"./puzzle/puzzle_106.png": 280,
	"./puzzle/puzzle_107": 281,
	"./puzzle/puzzle_107.png": 281,
	"./puzzle/puzzle_108": 282,
	"./puzzle/puzzle_108.png": 282,
	"./puzzle/puzzle_109": 283,
	"./puzzle/puzzle_109.png": 283,
	"./puzzle/puzzle_11": 284,
	"./puzzle/puzzle_11.png": 284,
	"./puzzle/puzzle_110": 285,
	"./puzzle/puzzle_110.png": 285,
	"./puzzle/puzzle_111": 286,
	"./puzzle/puzzle_111.png": 286,
	"./puzzle/puzzle_112": 287,
	"./puzzle/puzzle_112.png": 287,
	"./puzzle/puzzle_113": 288,
	"./puzzle/puzzle_113.png": 288,
	"./puzzle/puzzle_114": 289,
	"./puzzle/puzzle_114.png": 289,
	"./puzzle/puzzle_115": 290,
	"./puzzle/puzzle_115.png": 290,
	"./puzzle/puzzle_116": 291,
	"./puzzle/puzzle_116.png": 291,
	"./puzzle/puzzle_117": 292,
	"./puzzle/puzzle_117.png": 292,
	"./puzzle/puzzle_118": 293,
	"./puzzle/puzzle_118.png": 293,
	"./puzzle/puzzle_119": 294,
	"./puzzle/puzzle_119.png": 294,
	"./puzzle/puzzle_12": 295,
	"./puzzle/puzzle_12.png": 295,
	"./puzzle/puzzle_120": 296,
	"./puzzle/puzzle_120.png": 296,
	"./puzzle/puzzle_121": 297,
	"./puzzle/puzzle_121.png": 297,
	"./puzzle/puzzle_122": 298,
	"./puzzle/puzzle_122.png": 298,
	"./puzzle/puzzle_123": 299,
	"./puzzle/puzzle_123.png": 299,
	"./puzzle/puzzle_124": 300,
	"./puzzle/puzzle_124.png": 300,
	"./puzzle/puzzle_125": 301,
	"./puzzle/puzzle_125.png": 301,
	"./puzzle/puzzle_126": 302,
	"./puzzle/puzzle_126.png": 302,
	"./puzzle/puzzle_13": 303,
	"./puzzle/puzzle_13.png": 303,
	"./puzzle/puzzle_14": 304,
	"./puzzle/puzzle_14.png": 304,
	"./puzzle/puzzle_15": 305,
	"./puzzle/puzzle_15.png": 305,
	"./puzzle/puzzle_16": 306,
	"./puzzle/puzzle_16.png": 306,
	"./puzzle/puzzle_17": 307,
	"./puzzle/puzzle_17.png": 307,
	"./puzzle/puzzle_18": 308,
	"./puzzle/puzzle_18.png": 308,
	"./puzzle/puzzle_19": 309,
	"./puzzle/puzzle_19.png": 309,
	"./puzzle/puzzle_2": 310,
	"./puzzle/puzzle_2.png": 310,
	"./puzzle/puzzle_20": 311,
	"./puzzle/puzzle_20.png": 311,
	"./puzzle/puzzle_21": 312,
	"./puzzle/puzzle_21.png": 312,
	"./puzzle/puzzle_22": 313,
	"./puzzle/puzzle_22.png": 313,
	"./puzzle/puzzle_23": 314,
	"./puzzle/puzzle_23.png": 314,
	"./puzzle/puzzle_24": 315,
	"./puzzle/puzzle_24.png": 315,
	"./puzzle/puzzle_25": 316,
	"./puzzle/puzzle_25.png": 316,
	"./puzzle/puzzle_26": 317,
	"./puzzle/puzzle_26.png": 317,
	"./puzzle/puzzle_27": 318,
	"./puzzle/puzzle_27.png": 318,
	"./puzzle/puzzle_28": 319,
	"./puzzle/puzzle_28.png": 319,
	"./puzzle/puzzle_29": 320,
	"./puzzle/puzzle_29.png": 320,
	"./puzzle/puzzle_3": 321,
	"./puzzle/puzzle_3.png": 321,
	"./puzzle/puzzle_30": 322,
	"./puzzle/puzzle_30.png": 322,
	"./puzzle/puzzle_31": 323,
	"./puzzle/puzzle_31.png": 323,
	"./puzzle/puzzle_32": 324,
	"./puzzle/puzzle_32.png": 324,
	"./puzzle/puzzle_33": 325,
	"./puzzle/puzzle_33.png": 325,
	"./puzzle/puzzle_34": 326,
	"./puzzle/puzzle_34.png": 326,
	"./puzzle/puzzle_35": 327,
	"./puzzle/puzzle_35.png": 327,
	"./puzzle/puzzle_36": 328,
	"./puzzle/puzzle_36.png": 328,
	"./puzzle/puzzle_37": 329,
	"./puzzle/puzzle_37.png": 329,
	"./puzzle/puzzle_38": 330,
	"./puzzle/puzzle_38.png": 330,
	"./puzzle/puzzle_39": 331,
	"./puzzle/puzzle_39.png": 331,
	"./puzzle/puzzle_4": 332,
	"./puzzle/puzzle_4.png": 332,
	"./puzzle/puzzle_40": 333,
	"./puzzle/puzzle_40.png": 333,
	"./puzzle/puzzle_41": 334,
	"./puzzle/puzzle_41.png": 334,
	"./puzzle/puzzle_42": 335,
	"./puzzle/puzzle_42.png": 335,
	"./puzzle/puzzle_43": 336,
	"./puzzle/puzzle_43.png": 336,
	"./puzzle/puzzle_44": 337,
	"./puzzle/puzzle_44.png": 337,
	"./puzzle/puzzle_45": 338,
	"./puzzle/puzzle_45.png": 338,
	"./puzzle/puzzle_46": 339,
	"./puzzle/puzzle_46.png": 339,
	"./puzzle/puzzle_47": 340,
	"./puzzle/puzzle_47.png": 340,
	"./puzzle/puzzle_48": 341,
	"./puzzle/puzzle_48.png": 341,
	"./puzzle/puzzle_49": 342,
	"./puzzle/puzzle_49.png": 342,
	"./puzzle/puzzle_5": 343,
	"./puzzle/puzzle_5.png": 343,
	"./puzzle/puzzle_50": 344,
	"./puzzle/puzzle_50.png": 344,
	"./puzzle/puzzle_51": 345,
	"./puzzle/puzzle_51.png": 345,
	"./puzzle/puzzle_52": 346,
	"./puzzle/puzzle_52.png": 346,
	"./puzzle/puzzle_53": 347,
	"./puzzle/puzzle_53.png": 347,
	"./puzzle/puzzle_54": 348,
	"./puzzle/puzzle_54.png": 348,
	"./puzzle/puzzle_55": 349,
	"./puzzle/puzzle_55.png": 349,
	"./puzzle/puzzle_56": 350,
	"./puzzle/puzzle_56.png": 350,
	"./puzzle/puzzle_57": 351,
	"./puzzle/puzzle_57.png": 351,
	"./puzzle/puzzle_58": 352,
	"./puzzle/puzzle_58.png": 352,
	"./puzzle/puzzle_59": 353,
	"./puzzle/puzzle_59.png": 353,
	"./puzzle/puzzle_6": 354,
	"./puzzle/puzzle_6.png": 354,
	"./puzzle/puzzle_60": 355,
	"./puzzle/puzzle_60.png": 355,
	"./puzzle/puzzle_61": 356,
	"./puzzle/puzzle_61.png": 356,
	"./puzzle/puzzle_62": 357,
	"./puzzle/puzzle_62.png": 357,
	"./puzzle/puzzle_63": 358,
	"./puzzle/puzzle_63.png": 358,
	"./puzzle/puzzle_64": 359,
	"./puzzle/puzzle_64.png": 359,
	"./puzzle/puzzle_65": 360,
	"./puzzle/puzzle_65.png": 360,
	"./puzzle/puzzle_66": 361,
	"./puzzle/puzzle_66.png": 361,
	"./puzzle/puzzle_67": 362,
	"./puzzle/puzzle_67.png": 362,
	"./puzzle/puzzle_68": 363,
	"./puzzle/puzzle_68.png": 363,
	"./puzzle/puzzle_69": 364,
	"./puzzle/puzzle_69.png": 364,
	"./puzzle/puzzle_7": 365,
	"./puzzle/puzzle_7.png": 365,
	"./puzzle/puzzle_70": 366,
	"./puzzle/puzzle_70.png": 366,
	"./puzzle/puzzle_71": 367,
	"./puzzle/puzzle_71.png": 367,
	"./puzzle/puzzle_72": 368,
	"./puzzle/puzzle_72.png": 368,
	"./puzzle/puzzle_73": 369,
	"./puzzle/puzzle_73.png": 369,
	"./puzzle/puzzle_74": 370,
	"./puzzle/puzzle_74.png": 370,
	"./puzzle/puzzle_75": 371,
	"./puzzle/puzzle_75.png": 371,
	"./puzzle/puzzle_76": 372,
	"./puzzle/puzzle_76.png": 372,
	"./puzzle/puzzle_77": 373,
	"./puzzle/puzzle_77.png": 373,
	"./puzzle/puzzle_78": 374,
	"./puzzle/puzzle_78.png": 374,
	"./puzzle/puzzle_79": 375,
	"./puzzle/puzzle_79.png": 375,
	"./puzzle/puzzle_8": 376,
	"./puzzle/puzzle_8.png": 376,
	"./puzzle/puzzle_80": 377,
	"./puzzle/puzzle_80.png": 377,
	"./puzzle/puzzle_81": 378,
	"./puzzle/puzzle_81.png": 378,
	"./puzzle/puzzle_82": 379,
	"./puzzle/puzzle_82.png": 379,
	"./puzzle/puzzle_83": 380,
	"./puzzle/puzzle_83.png": 380,
	"./puzzle/puzzle_84": 381,
	"./puzzle/puzzle_84.png": 381,
	"./puzzle/puzzle_85": 382,
	"./puzzle/puzzle_85.png": 382,
	"./puzzle/puzzle_86": 383,
	"./puzzle/puzzle_86.png": 383,
	"./puzzle/puzzle_87": 384,
	"./puzzle/puzzle_87.png": 384,
	"./puzzle/puzzle_88": 385,
	"./puzzle/puzzle_88.png": 385,
	"./puzzle/puzzle_89": 386,
	"./puzzle/puzzle_89.png": 386,
	"./puzzle/puzzle_9": 387,
	"./puzzle/puzzle_9.png": 387,
	"./puzzle/puzzle_90": 388,
	"./puzzle/puzzle_90.png": 388,
	"./puzzle/puzzle_91": 389,
	"./puzzle/puzzle_91.png": 389,
	"./puzzle/puzzle_92": 390,
	"./puzzle/puzzle_92.png": 390,
	"./puzzle/puzzle_93": 391,
	"./puzzle/puzzle_93.png": 391,
	"./puzzle/puzzle_94": 392,
	"./puzzle/puzzle_94.png": 392,
	"./puzzle/puzzle_95": 393,
	"./puzzle/puzzle_95.png": 393,
	"./puzzle/puzzle_96": 394,
	"./puzzle/puzzle_96.png": 394,
	"./puzzle/puzzle_97": 395,
	"./puzzle/puzzle_97.png": 395,
	"./puzzle/puzzle_98": 396,
	"./puzzle/puzzle_98.png": 396,
	"./puzzle/puzzle_99": 397,
	"./puzzle/puzzle_99.png": 397,
	"./relogio": 398,
	"./relogio.png": 398,
	"./replay": 165,
	"./replay.png": 165,
	"./replay.svg": 525,
	"./sebastiao_a_pensar": 399,
	"./sebastiao_a_pensar.png": 399,
	"./sebastiao_nervoso": 400,
	"./sebastiao_nervoso.png": 400,
	"./sebastiao_saltitao": 401,
	"./sebastiao_saltitao.png": 401,
	"./sebastiao_sobre": 402,
	"./sebastiao_sobre.png": 402,
	"./sebastiao_triste": 403,
	"./sebastiao_triste.png": 403,
	"./sensacoes": 404,
	"./sensacoes.svg": 404,
	"./silhueta": 405,
	"./silhueta.svg": 405,
	"./team/AlziraAlbuquerque": 406,
	"./team/AlziraAlbuquerque.png": 406,
	"./team/AnaCarolinaGois": 407,
	"./team/AnaCarolinaGois.png": 407,
	"./team/AnaDiasFonseca": 408,
	"./team/AnaDiasFonseca.png": 408,
	"./team/AnaIsabelPereira": 409,
	"./team/AnaIsabelPereira.png": 409,
	"./team/AnaMariaPereira": 410,
	"./team/AnaMariaPereira.png": 410,
	"./team/BarbaraPereira": 411,
	"./team/BarbaraPereira.png": 411,
	"./team/BrigidaCaiado": 412,
	"./team/BrigidaCaiado.png": 412,
	"./team/BrunaPaulino": 413,
	"./team/BrunaPaulino.png": 413,
	"./team/CatarinaSantos": 414,
	"./team/CatarinaSantos.png": 414,
	"./team/DianaSantos": 415,
	"./team/DianaSantos.png": 415,
	"./team/HelenaMoreira": 416,
	"./team/HelenaMoreira.png": 416,
	"./team/JillEhrenreichMay": 417,
	"./team/JillEhrenreichMay.png": 417,
	"./team/JorgeOsmaLopez": 418,
	"./team/JorgeOsmaLopez.png": 418,
	"./team/MagdaRoberto": 419,
	"./team/MagdaRoberto.png": 419,
	"./team/MariaCristinaCanavarro": 420,
	"./team/MariaCristinaCanavarro.png": 420,
	"./team/MarianaSaraiva": 421,
	"./team/MarianaSaraiva.png": 421,
	"./team/VitoriaNunesVicente": 422,
	"./team/VitoriaNunesVicente.png": 422,
	"./trofeu": 423,
	"./trofeu.svg": 423,
	"./vantagens": 424,
	"./vantagens.svg": 424,
	"./vantagens_desvantagens": 425,
	"./vantagens_desvantagens.svg": 425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 522;